var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MhRouterView',{staticClass:"EditView view maxWidth maxWidth--appBody",attrs:{"isContentReady":_vm.isContentReady}},[_c('div',{staticClass:"EditView__inner view__inner"},[_c('DocEditForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }